import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Grid,
    Button,
    Typography,
} from '@material-ui/core';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { Tooltip } from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MonetizationOnRoundedIcon from '@material-ui/icons/MonetizationOnRounded';
import IconButton from '@material-ui/core/IconButton';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { PaymentData } from 'src/reducers/payment';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import FilterListIcon from '@material-ui/icons/FilterList';
import PrintIcon from '@material-ui/icons/Print';

interface TableState {
    columns: Array<Column<PaymentData>>;
    data: PaymentData[];
}

export interface PaymentRequestPageProps {
    paymentData: PaymentData[];
    details: (total: number, tableData: PaymentData[] | PaymentData) => void;
    isWaiting: boolean;
    paymentId: string;
    // paymentAmount: (amount: number) => void;
    // unitTotal: (units: number) => void;
    paymentCall: (amount: number) => void;
    // totalAmount: number;
    // totalUnits: number;

    fDate: (fromDate: Date | null) => void;
    toDate: (todate: Date | null) => void;

    startDate: Date | null;
    endDate: Date | null;

    dateFilter: () => void;
    dateReset: () => void;

    isWaitingClose: () => void;
    reload: () => void;
    printTxn: (txn: String) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 500,
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        color: {
            backgroundColor: '#23a710e6',
            color: '#fff'
        },
        paymentButton: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            // margin: '12px',
            position: 'absolute',
            right: 0,
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            }
        },
        dialogContent: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '50px'
        },
        dialogContentAlert: {
            textAlign: 'center',
            fontWeight: 'bolder',
            fontSize: '30px'
        },
        money: {
            color: '#8bc34a',
            fontSize: 40,
            margin: '0 5px',
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px'
        },
        dialogAction: {
            justifyContent: 'center',
        },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        underline: {
            textDecoration: 'underline',
            textTransform: 'uppercase'
        },
        right: {
            textAlign: 'right',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121'
        },
        left: {
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '25px',
            color: '#212121bd'
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        dialog: {
            margin: theme.spacing(2)
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        }
    })
);

export const PaymentPage: React.StatelessComponent<PaymentRequestPageProps> = (props) => {
    const classes = useStyles({});
    const [open, setOpen] = React.useState(false);
    const [openYorN, setOpenYorN] = React.useState(false);
    const [amount, setAmount] = React.useState(0);
    const [units, setUnits] = React.useState(0);
    const [rowDatas, setRowdata] = React.useState<PaymentData[] | PaymentData>([]);

    const amountTotal = (tableData: PaymentData[] | PaymentData) => {
        if (Array.isArray(tableData)) {
            const result = tableData.reduce((tot: number, rowdata: PaymentData) => tot + parseFloat(rowdata.outstanding), 0);
            setAmount(result);
        } else {
            setAmount(parseFloat(tableData.outstanding));
            // // ==> console.error(parseFloat(tableData.invamount, 10), 'singleAmount');
        }
    };
    const unitTotal = (tableData: PaymentData[] | PaymentData) => {
        if (Array.isArray(tableData)) {
            const result = tableData.reduce((tot: number, rowdata: PaymentData) => tot + parseFloat(rowdata.totunits), 0);
            setUnits(result);
        } else {
            setUnits(parseFloat(tableData.totunits));
            // // ==> console.error(parseFloat(tableData.totunits, 10), 'singleUnits');
        }
    };

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(5);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<PaymentData[]>([]);

    const handleSelectAll = (tableData: PaymentData[]) => {
        setSelectedRowsArray(tableData.slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: PaymentData) => {

        if (tableData.invoiceno) {
            setSelectedRowsArray((items: PaymentData[]) => {
                if (items.find(_d => _d.orderno === tableData.invoiceno)?.invoiceno) {
                    return items.filter((item) => item.invoiceno !== tableData.invoiceno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const handleClickOpen = (tableData: PaymentData[] | PaymentData) => {
        // let total = 0;
        // const rowData: PaymentData[] | PaymentData = tableData;
        setRowdata(selectedRowsArray);
        amountTotal(selectedRowsArray);
        unitTotal(selectedRowsArray);
        // props.paymentAmount(amount);
        // props.unitTotal(units);
        setOpenYorN(true);
    };

    const paymentClickOpen = () => {
        if (amount >= 0) {
            props.details(amount, rowDatas);
            setOpenYorN(false);
            setOpen(true);
        } else {
            setOpenYorN(false);
        }
    };

    const handleClose = () => {
        setOpenYorN(false);
    };
    const paymentClose = () => {
        setAmount(0);
        setOpen(false);
        props.isWaitingClose();
        // props.isWaiting = !props.isWaiting;
    };
    const paymentResult = () => {
        props.paymentCall(amount);
        setAmount(0);
        setOpen(false);
    };
    // const supportType = ['NaN', 'Cancel Order', 'Re-Design Request', 'Quality Concern', 'Billing / Payment', 'Portal Related', 'Others'];
    const [state] = React.useState<TableState>({
        columns: [
            { title: 'Invoice No', field: 'invoiceno' },
            { title: 'Invoice Date', field: 'invoicedate' },
            { title: 'Order No', field: 'orderno' },
            { title: 'TAT', field: 'tattype' },
            { title: 'Due Date', field: 'duedate' },
            { title: 'Invoice Amount', field: 'invamount', render: rowData => (`$ ${parseFloat(rowData.invamount)}`) },
            { title: 'Outstanding Amount', field: 'outstanding', render: rowData => (parseFloat(rowData.outstanding) ? `$ ${parseFloat(rowData.outstanding)}` : `$ ${rowData.outstanding}`) },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                render: rowData => (
                    <div style={{ display: 'flex' }}>
                        <Tooltip title="Print" placement="top">
                            <IconButton aria-label="view" onClick={() => parseFloat(rowData.outstanding) && props.printTxn(rowData.invoiceno)}>
                                <PrintIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        data: props.paymentData
    });

    const [dialogOpen, setdialogOpen] = React.useState(false);

    const handleClickDialog = () => {
        setdialogOpen(true);
    };

    const handleCloseDialog = () => {
        setdialogOpen(false);
    };

    const submitDialog = () => {
        props.dateFilter();
        setdialogOpen(false);
    };
    const resetDialog = () => {
        props.dateReset();
        setdialogOpen(false);
    };

    // // ==> console.error(props.isWaiting, 'four');
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClickDialog}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={openYorN}
                            // onClose={handleClose}
                            fullWidth
                            maxWidth="sm"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle
                                id="customized-dialog-title"
                                className={classes.dialogTitle}
                                disableTypography
                            >
                                <Typography variant="h6" className={classes.underline}>
                                    Payment Confirmation
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText id="alert-dialog-description" className={classes.dialogContent}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} className={classes.right}>
                                            Total Units :
                                        </Grid>
                                        <Grid item xs={12} sm={6} className={classes.left}>{units}</Grid>
                                        <Grid item xs={12} sm={12}>
                                            <MonetizationOnRoundedIcon className={classes.money} />{`${amount}`}
                                        </Grid>
                                    </Grid>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={paymentClickOpen} color="primary" autoFocus>
                                    Yes
                                </Button>
                                <Button onClick={handleClose} color="secondary">
                                    No
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={open}
                            // onClose={paymentClose}
                            fullWidth
                            maxWidth="sm"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle
                                id="customized-dialog-title"
                                className={classes.dialogTitle}
                                disableTypography
                            >
                                <Typography variant="h6" className={classes.underline}>
                                    Proceed to Payment Gateway
                                </Typography>
                                <IconButton onClick={paymentClose} className={classes.iconClose}>
                                    <CloseRoundedIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent dividers>
                                <DialogContentText id="alert-dialog-description" className={classes.dialogContent}>
                                    {props.isWaiting === true ? <CircularProgress /> : <div>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6} className={classes.right}>
                                                Reference Id :
                                            </Grid>
                                            <Grid item xs={12} sm={6} className={classes.left}>{props.paymentId}</Grid>
                                            <Grid item xs={12} sm={6} className={classes.right}>
                                                Total Units :
                                            </Grid>
                                            <Grid item xs={12} sm={6} className={classes.left}>{units}</Grid>
                                            <Grid item xs={12} sm={12}>
                                                <MonetizationOnRoundedIcon className={classes.money} />{`${amount}`}
                                            </Grid>
                                        </Grid>
                                        {/* <Typography variant="h6">
                                            Reference Id: {props.paymentId}
                                        </Typography>
                                        <Typography variant="h6">
                                            Total Units: {props.totalUnits}
                                        </Typography> */}
                                        {/* <MonetizationOnRoundedIcon className={classes.money} />{`${amount}`} */}
                                    </div>}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className={classes.dialogAction}>
                                <Button onClick={paymentResult} variant="outlined" disabled={props.isWaiting === true ? true : false} color="primary" >
                                    Pay
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {/* <Tooltip title="Payment" placement="top" arrow>
                            <Button
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                className={classes.paymentButton}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    endIcon={<PaymentIcon />}
                                >
                                    Pay
                                </Button>
                            </Button>
                        </Tooltip> */}
                        <Dialog
                            open={dialogOpen}
                            onClose={handleCloseDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title"><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Date Filter</Typography></DialogTitle>
                            <DialogContent>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <div className={classes.dialog}>
                                        <Grid container justify="space-around" spacing={2}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                value={props.startDate}
                                                onChange={props.fDate}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </Grid>
                                        <Grid container justify="space-around" spacing={2}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date-picker-dialog-2"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                value={props.endDate}
                                                onChange={props.toDate}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                            />
                                        </Grid>
                                    </div>
                                </MuiPickersUtilsProvider>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitDialog}
                                >
                                    Submit
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={resetDialog}
                                    className={classes.HeadinG}
                                >
                                    Reset
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <MaterialTable
                            title="Open Invoices"
                            columns={state.columns}
                            data={props.paymentData}
                            localization={{
                                toolbar: {
                                    nRowsSelected: `${selectedRowsArray.length} selected`,
                                    exportTitle: 'Export as Excel'
                                },
                                header: {
                                    actions: ''
                                }
                            }}
                            options={{
                                selection: true,
                                pageSizeOptions: [5, 10, 25, 50, 100],
                                sorting: false,
                                actionsColumnIndex: -1,
                                headerStyle: {
                                    backgroundColor: '#757575',
                                    color: '#fff',
                                    padding: '5px 10px',
                                },
                                selectionProps: (selecrowData: PaymentData) => {
                                    const check = (selectedRowsArray.find(_d => _d.invoiceno === selecrowData.invoiceno)?.invoiceno) ? { checked: true } : { checked: false };
                                    return {
                                        ...check
                                    };
                                }
                            }}
                            onSelectionChange={
                                (rows, rowData) => {
                                    if (!rowData) {
                                        handleSelectAll(rows);
                                    } else {
                                        handleSelectOne(rowData);
                                    }
                                }
                            }
                            onChangePage={
                                (pageno) => {
                                    setPage(pageno);
                                }
                            }
                            onChangeRowsPerPage={
                                (pageSize) => {
                                    if (pageSize !== size) {
                                        if (pageSize > size) {
                                            setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.paymentData.length / 5), 0)));
                                        } else {
                                            setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.paymentData.length / 5), 0)));
                                        }
                                    }
                                    setSize(pageSize);
                                }
                            }
                            actions={[
                                {
                                    icon: () => (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            endIcon={<PaymentIcon />}
                                        >
                                            Pay
                                        </Button>),
                                    tooltip: 'Payment',
                                    isFreeAction: false,
                                    onClick: (event, tableData) => {
                                        handleClickOpen(tableData);
                                        // // ==> console.error(tableData);
                                    }
                                },
                            ]}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default PaymentPage;



// WEBPACK FOOTER //
// ./src/components/layouts/PaymentPageView.tsx